<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow v-if="farmerId" :confirm="true"
                    :title="$t('Modify') + ' ' + $t('a') + ' ' + $t('farmer')" route-back="FarmerIndex"/>
        <back-arrow v-else :confirm="askConfirm" :title="$t('Add') + ' ' + $t('a')  + ' ' +  $t('farmer')"
                    route-back="FarmerIndex"/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm card-scrollable">
            <b-form @submit.stop.prevent="onSubmit">

              <div class="row">
                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.cheptelNumber.invalidFeedback"
                    :label="$t('farmer.num.Cheptel')"
                    :state="form.cheptelNumber.state"
                    class="medium-label mb-4 required-input"
                    label-for="cheptelNumber-input">
                    <b-form-input
                      id="cheptelNumber-input"
                      v-model="form.cheptelNumber.value"
                      :state="form.cheptelNumber.state"
                      required
                      tabindex="1"
                      type="text"
                      maxlength="8"
                      @keypress="$event.key.match(/^[\d\.]$/) ? '' : $event.preventDefault()"
                      v-on:change="removeInvalidFeedback('cheptelNumber'); askConfirm=true">
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.farmName.invalidFeedback"
                    :label="$t('farmer.name.elevage')"
                    :state="form.farmName.state"
                    class="medium-label mb-4"
                    label-for="farmName-input">
                    <b-form-input
                      id="farmName-input"
                      v-model="form.farmName.value"
                      :state="form.farmName.state"
                      tabindex="2"
                      type="text"
                      v-on:change="removeInvalidFeedback('farmName'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.lastName.invalidFeedback"
                    :label="$t('farmer.lastName')"
                    :state="form.lastName.state"
                    class="medium-label mb-4 required-input"
                    label-for="lastName-input">
                    <b-form-input
                      id="lastName-input"
                      v-model="form.lastName.value"
                      :state="form.lastName.state"
                      maxlength="250"
                      required
                      tabindex="3"
                      type="text"
                      v-on:change="removeInvalidFeedback('lastName');askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.firstName.invalidFeedback"
                    :label="$t('farmer.firstName')"
                    :state="form.firstName.state"
                    class="medium-label mb-4 required-input"
                    label-for="firstName-input">
                    <b-form-input
                      id="firstName-input"
                      v-model="form.firstName.value"
                      :state="form.firstName.state"
                      maxlength="250"
                      required
                      tabindex="4"
                      type="text"
                      v-on:change="removeInvalidFeedback('firstName'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.phoneNumber.invalidFeedback"
                    :label="$t('farmer.phoneNumber')"
                    :state="form.phoneNumber.state"
                    class="medium-label mb-4 required-input"
                    label-for="phoneNumber-input">
                    <vue-phone-number-input
                      id="phone-input"
                      v-model="form.phoneNumber.inputValue"
                      :error="form.phoneNumber.error"
                      :placeholder="$t('farmer.phoneNumber')"
                      tabindex="5"
                      required
                      @update="checkPhone"/>
                  </b-form-group>
                </div>

                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.username.invalidFeedback"
                    :label="$t('farmer.username')"
                    :state="form.username.state"
                    class="medium-label mb-4 required-input"
                    label-for="username-input">
                    <b-form-input
                      id="username-input"
                      v-model="form.username.value"
                      :state="form.username.state"
                      required
                      tabindex="6"
                      type="email"
                      v-on:change="removeInvalidFeedback('username'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.address.invalidFeedback"
                    :label="$t('farmer.address')"
                    :state="form.address.state"
                    class="medium-label mb-4 required-input"
                    label-for="address-input">
                    <b-form-input
                      id="address-input"
                      v-model="form.address.value"
                      :state="form.address.state"
                      required
                      tabindex="7"
                      v-on:change="removeInvalidFeedback('address'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.addressDetails.invalidFeedback"
                    :label="$t('farmer.address.details')"
                    :state="form.addressDetails.state"
                    class="medium-label mb-4"
                    label-for="addressDetails-input">
                    <b-form-input
                      id="addressDetails-input"
                      v-model="form.addressDetails.value"
                      :state="form.addressDetails.state"
                      tabindex="8"
                      v-on:change="removeInvalidFeedback('addressDetails'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.postalCode.invalidFeedback"
                    :label="$t('farmer.postalCode')"
                    :state="form.postalCode.state"
                    class="medium-label mb-4 required-input"
                    label-for="postalCode-input">
                    <b-form-input
                      id="postalCode-input"
                      v-model="form.postalCode.value"
                      :state="form.postalCode.state"
                      required
                      tabindex="9"
                      v-on:change="removeInvalidFeedback('postalCode'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.city.invalidFeedback"
                    :label="$t('farmer.city')"
                    :state="form.city.state"
                    class="medium-label mb-4 required-input"
                    label-for="city-input">
                    <b-form-input
                      id="city-input"
                      v-model="form.city.value"
                      :state="form.city.state"
                      required
                      tabindex="10"
                      v-on:change="removeInvalidFeedback('city'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.structure.invalidFeedback"
                    :label="$t('farmer.structure')"
                    :state="form.structure.state"
                    class="medium-label mb-4"
                    label-for="structure-input">
                    <b-form-select
                      :disabled="!(this.$store.getters.isAdmin || this.$store.getters.isSuperAdmin || structures.length>1)"
                      id="structure-input"
                      v-model="form.structure.value"
                      :state="form.structure.state"
                      required
                      tabindex="11"
                      v-on:change="askConfirm=true;">
                      <template v-if="structures.length === 0" #first>
                        <b-form-select-option :value="null" disabled></b-form-select-option>
                      </template>
                      <option v-for="option in structures" :value="option.id">
                        {{ option.tostring }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </div>
                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.technician.invalidFeedback"
                    :label="$t('farmer.technician')"
                    :state="form.technician.state"
                    class="medium-label mb-4"
                    label-for="technician-input">
                    <b-form-select
                      id="technician-input"
                      v-model="form.technician.value"
                      :state="form.technician.state"
                      :disabled="(this.$store.getters.isTechnician&&!this.$store.getters.isStructure) || this.form.structure.value === null || technicians.length === 0"
                      required
                      tabindex="12"
                      v-on:change="askConfirm=true;">
                      <option v-for="option in technicians" :value="option.id">
                        {{ option.tostring }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="d-flex justify-content-end">
                <b-button tabindex="13" type="submit" variant="primary">
                  {{ farmerId ? $t('Modify') : $t('Add') + ' ' + $t('l.i') + $t('farmer') }}
                </b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>

    <user-already-exist></user-already-exist>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import DateField from '../../components/b122/editFields/DateField'
import PasswordCreationField from '../../components/b122/editFields/PasswordCreationField'
import UserAlreadyExist from '../user/UserAlreadyExist'
import {bus} from '../../main'

export default {

  name: 'FarmerCreateEdit',

  components: {
    BackArrow,
    DateField,
    PasswordCreationField,
    UserAlreadyExist
  },

  data () {
    return {
      farmerId: this.$route.params.farmerId,
      askConfirm: false,
      form: {
        firstName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lastName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        username:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        phoneNumber:
          {
            state: null,
            invalidFeedback: null,
            error: null,
            value: null,
            inputValue: null
          },
        address:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        addressDetails:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        postalCode:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        city:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        farmName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        cheptelNumber:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        password:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        structure:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        technician:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      },
      structures: [
        {value: 0, text: 'Aucune structure'}
      ],
      technicians: [
        {value: 0, text: 'Aucun technicien'}
      ],
      farmer: {},
      showPassword: true
    }
  },

  mounted () {
    this.fetchData()
  },

  created () {
    bus.$on('handleSubmit', this.submitCreateEdit)
  },
  beforeDestroy () {
    bus.$off('handleSubmit', this.submitCreateEdit)
  },

  watch: {
    'form.structure.value': async function () {
      await this.fetchAllTechnicianByStructure()
    }
  },
  methods: {

    async fetchData () {
      await this.fetchAllStructure()
      if (this.farmerId) {
        await this.fetchFarmer()
      }
    },

    async fetchFarmer () {
      api
        .get('/farmer/' + this.farmerId)
        .then(response => {
          this.farmer = response.data
          this.setInitialValues()
        })
    },

    setInitialValues () {
      if (this.farmer != null) {
        this.form.farmName.value = this.farmer.farmName
        this.form.cheptelNumber.value = this.farmer.cheptelNumber
        this.form.firstName.value = this.farmer.user.firstName
        this.form.lastName.value = this.farmer.user.lastName
        this.form.username.value = this.farmer.user.username
        this.form.phoneNumber.value = this.farmer.user.phoneNumber
        this.form.phoneNumber.inputValue = this.farmer.user.phoneNumber
        this.form.address.value = this.farmer.address
        this.form.addressDetails.value = this.farmer.addressDetails !== 'null' ? this.farmer.addressDetails : null
        this.form.postalCode.value = this.farmer.postalCode
        this.form.city.value = this.farmer.city
        this.form.technician.value = this.farmer.technician.id
        this.form.structure.value = this.farmer.structure.id
      }
    },

    async fetchAllStructure () {
      await api
        .get('/structure/getAllStructure/')
        .then(response => {
          this.structures = response.data
          if (!this.form.structure.value) {
            const defaultStructure = this.structures.find((structure) => structure.name === 'Aucune structure')
            if (defaultStructure) {
              this.form.structure.value = defaultStructure.id
            } else if (this.structures.length >= 1) {
              this.form.structure.value = this.structures[0].id
            }
          }
        })
    },

    async fetchAllTechnicianByStructure () {
      await api.get('/technician/getAllTechnicianByStructure/' + this.form.structure.value)
        .then(response => {
          this.technicians = response.data
          if (!this.form.technician.value) {
            const defaultTechnician = this.technicians.find((technician) => technician.lastName === 'Aucun' && technician.firstName === 'technicien')
            if (defaultTechnician) {
              this.form.technician.value = defaultTechnician.id
            } else if (this.technicians.length >= 1) {
              this.form.technician.value = this.technicians[0].id
            }
          }
        })
    },

    async onSubmit () {
      await this.fetchUserAlreadyExist()
    },

    async fetchUserAlreadyExist () {
      let data = new FormData()
      data.append('objectType', 'Farmer')
      if (this.farmer.id) {
        data.append('objectId', this.farmer.id)
      }
      data.append('username', this.form.username.value)
      await api({
        method: 'post',
        url: '/user/isUserAlreadyExist',
        data: data
      })
        .then(async (response) => {
          if (response.status === 200) {
            await this.submitCreateEdit()
          } else if (response.status === 202) {
            if (response.data.user) {
              bus.$emit('toggleModal', response.data.user)
            }
          }
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'FarmerIndex'
            })
          } else {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    async submitCreateEdit () {
      let data = new FormData()
      data.append('firstName', this.form.firstName.value)
      data.append('lastName', this.form.lastName.value)
      data.append('username', this.form.username.value)
      data.append('phoneNumber', this.form.phoneNumber.value.e164)
      data.append('farmName', this.form.farmName.value)
      data.append('address', this.form.address.value)
      data.append('addressDetails', this.form.addressDetails.value)
      data.append('postalCode', this.form.postalCode.value)
      data.append('city', this.form.city.value)
      data.append('structureId', this.form.structure.value)
      data.append('technicianId', this.form.technician.value)
      data.append('cheptelNumber', this.form.cheptelNumber.value)

      let url = 'farmer'
      if (this.farmerId) {
        url = '/farmer/' + this.farmerId
      }

      await api({
        method: 'POST',
        url: url,
        data: data
      })
        .then((response) => {
          this.structure = response.data
          this.$router.push({
            name: 'FarmerIndex'
          },
          () => {
            this.$nextTick(() => {
              this.successToast(this.form.firstName.value + ' ' + this.form.lastName.value)
            })
          })
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'FarmerIndex'
            })
          } else {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    removeInvalidFeedback (field) {
      this.form[field]['state'] = null
    },
    checkPhone (value) {
      this.form.phoneNumber.error = false
      this.form.phoneNumber.value = value
      this.removeInvalidFeedback('phoneNumber')
      this.askConfirm = true
    },

    successToast (taskName) {
      this.$bvToast.toast(this.$i18n.t('Farmer') + ' "' + taskName + '" ' + this.$i18n.t('f.registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true
      })
    }


  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/farmer/FarmerCreateEdit.vue